import { instance3 } from "App/constants"
import { oneMonthBeforeToday, today } from "App/utils/helpers"
import moment from "moment"
import { toFirstHoursDay, toLastHoursDay } from "utils/dates"

export const urlGet = "/rekap-tagihan/list"
export const urlExport = "/rekap-tagihan/list-export"
// export const urlGetRekapTagihanById = "/rekap-tagihan/details-by-id";
export const urlGetRekapTagihanById = "/rekap-tagihan/details-v2-by-id"
export const urlDelete = "/wmsfarmasi/pembelian/delete"

export const RESET_STATE_FORM_FILTER = {
  pages: 1,
  limit: 10,

  kategori: 0,
  rekap_tagihan_id: "",
  no_surat: "",

  status_transaksi: null,
  status_transaksi_name: "Pilih Status",

  status_proses_id: null,
  status_proses_name: "Pilih Status Proses",

  jenis_asuransi_id: "",
  jenis_asuransi_nama: "Pilih Instansi Asuransi",

  asuransi_id: "",
  asuransi_nama: "Pilih Asuransi",

  tanggal_awal: toFirstHoursDay(oneMonthBeforeToday(true)),
  tanggal_akhir: toLastHoursDay(today(true)),
}

export const getByFilterRekapTagihan = async (formFilter, pages, limit) => {
  try {
    const data = {
      halaman: pages,
      jumlah: limit,

      kategori: formFilter.kategori,
      id: formFilter.rekap_tagihan_id,
      no_surat: formFilter.no_surat,

      status_transaksi: formFilter.status_transaksi,
      jenis_asuransi_id: formFilter.jenis_asuransi_id,
      asuransi_id: formFilter.asuransi_id,

      tglAwal: moment(formFilter.tanggal_awal).format("YYYY-MM-DD"),
      tglAkhir: moment(formFilter.tanggal_akhir).format("YYYY-MM-DD"),
      jamAwal: moment(formFilter.tanggal_awal).format("HH:mm"),
      jamAkhir: moment(formFilter.tanggal_akhir).format("HH:mm"),

      company_id: formFilter.company_id,
    }

    const api = await instance3.post(urlGet, {
      ...data,
    })

    const res = api.data
    if (res.status === 200) {
      return {
        state: true,
        data: res.body,
        meta: {
          count: parseInt(res.count),
          pages: parseInt(res.halaman),
          limit: parseInt(res.jumlah),
        },
      }
    } else {
      return {
        state: false,
        data: [],
        meta: {
          count: 0,
          pages: 1,
          limit: 10,
        },
      }
    }
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    }
  }
}

export const getExportRekapTagihan = async (formFilter) => {
  try {
    const data = {
      kategori: formFilter.kategori,
      id: formFilter.rekap_tagihan_id,
      no_surat: formFilter.no_surat,

      status_transaksi: formFilter.status_transaksi,
      jenis_asuransi_id: formFilter.jenis_asuransi_id,
      asuransi_id: formFilter.asuransi_id,

      tglAwal: moment(formFilter.tanggal_awal).format("YYYY-MM-DD"),
      tglAkhir: moment(formFilter.tanggal_akhir).format("YYYY-MM-DD"),
      jamAwal: moment(formFilter.tanggal_awal).format("HH:mm"),
      jamAkhir: moment(formFilter.tanggal_akhir).format("HH:mm"),
    }

    const api = await instance3.post(urlExport, {
      ...data,
    })

    const res = api.data
    if (res.status === 200) {
      return {
        state: true,
        message: res.message,
      }
    } else {
      return {
        state: false,
        message: res.message,
      }
    }
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    }
  }
}

export const getRekapTagihanById = async (id) => {
  try {
    const api = await instance3.get(`${urlGetRekapTagihanById}/${id}`)
    const res = api.data
    if (api.status === 200) {
      return {
        state: true,
        data: res.data,
        detail: res.data.detail,
      }
    } else {
      return {
        state: false,
        message: res.data.message,
      }
    }
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    }
  }
}

export const headCells = [
  {
    id: "no",
    disablePadding: false,
    label: "NO",
    align: "center",
    sort: false,
  },
  {
    id: "act",
    disablePadding: true,
    label: "ACT",
    sort: false,
    align: "left",
  },
  {
    id: "id",
    disablePadding: false,
    label: "ID",
    align: "left",
  },
  {
    id: "no_surat",
    disablePadding: false,
    label: "NO SURAT",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "no_resi",
    disablePadding: false,
    label: "NO. RESI",
    align: "left",
    minWidth: "100px",
  },
  {
    id: "tanggal",
    disablePadding: false,
    label: "TANGGAL",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "tanggal_awal_periode",
    disablePadding: false,
    label: "TANGGAL AWAL PERIODE",
    align: "left",
    minWidth: "190px",
  },
  {
    id: "tanggal_akhir_periode",
    disablePadding: false,
    label: "TANGGAL AKHIR PERIODE",
    align: "left",
    minWidth: "190px",
  },
  {
    id: "tanggal_tagih",
    disablePadding: false,
    label: "TANGGAL TAGIH",
    align: "left",
    minWidth: "180px",
  },
  {
    id: "penerima",
    disablePadding: false,
    label: "PENERIMA",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "klien",
    disablePadding: false,
    label: "ASURANSI",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "perusahaan",
    disablePadding: false,
    label: "PERUSAHAAN",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "status",
    disablePadding: false,
    label: "STATUS",
    align: "left",
    minWidth: "100px",
  },
  {
    id: "tgl_tutup",
    disablePadding: false,
    label: "TANGGAL TUTUP",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "totalData",
    disablePadding: false,
    label: "TOTAL DATA",
    align: "left",
    minWidth: "130px",
  },
  {
    id: "totalTagihan",
    disablePadding: false,
    label: "TOTAL TAGIHAN",
    align: "left",
    minWidth: "200px",
  },
  {
    id: "bayarDalamTagih",
    disablePadding: false,
    label: "BAYAR DALAM TAGIHAN",
    align: "left",
    minWidth: "200px",
  },
  {
    id: "diskon",
    disablePadding: false,
    label: "DISKON",
    align: "left",
    minWidth: "200px",
  },
  {
    id: "bayarDalamRekap",
    disablePadding: false,
    label: "BAYAR DALAM REKAP",
    align: "left",
    minWidth: "200px",
  },
  {
    id: "bayarGabungan",
    disablePadding: false,
    label: "BAYAR GABUNGAN",
    align: "left",
    minWidth: "200px",
  },
  {
    id: "sisa",
    disablePadding: false,
    label: "SISA DALAM REKAP",
    align: "left",
    minWidth: "200px",
  },
  {
    id: "createdAt",
    disablePadding: false,
    label: "INSERTED TIME",
    sort: false,
    minWidth: "150px",
  },
  {
    id: "createdBy",
    disablePadding: false,
    label: "INSERTED BY",
    sort: false,
    minWidth: "150px",
  },
  {
    id: "updatedAt",
    disablePadding: false,
    label: "UPDATED TIME",
    sort: false,
    minWidth: "170px",
  },
  {
    id: "updatedBy",
    disablePadding: false,
    label: "UPDATED BY",
    sort: false,
    minWidth: "150px",
  },
]

export const headCellsExport = [
  {
    id: "no",
    disablePadding: false,
    label: "NO",
    align: "center",
    sort: false,
  },
  {
    id: "id",
    disablePadding: false,
    label: "ID",
    align: "left",
  },
  {
    id: "no_surat",
    disablePadding: false,
    label: "NO SURAT",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "no_resi",
    disablePadding: false,
    label: "NO. RESI",
    align: "left",
    minWidth: "100px",
  },
  {
    id: "tanggal",
    disablePadding: false,
    label: "TANGGAL",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "tanggal_awal_periode",
    disablePadding: false,
    label: "TANGGAL AWAL PERIODE",
    align: "left",
    minWidth: "190px",
  },
  {
    id: "tanggal_akhir_periode",
    disablePadding: false,
    label: "TANGGAL AKHIR PERIODE",
    align: "left",
    minWidth: "190px",
  },
  {
    id: "tanggal_tagih",
    disablePadding: false,
    label: "TANGGAL TAGIH",
    align: "left",
    minWidth: "180px",
  },
  {
    id: "tanggal_jatuh_tempo",
    disablePadding: false,
    label: "TANGGAL JATUH TEMPO",
    align: "left",
    minWidth: "180px",
  },
  {
    id: "penerima",
    disablePadding: false,
    label: "PENERIMA",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "klien",
    disablePadding: false,
    label: "PERUSAHAAN/ASURANSI",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "status",
    disablePadding: false,
    label: "STATUS",
    align: "left",
    minWidth: "100px",
  },
  {
    id: "tgl_tutup",
    disablePadding: false,
    label: "TANGGAL TUTUP",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "totalData",
    disablePadding: false,
    label: "TOTAL DATA",
    align: "left",
    minWidth: "130px",
  },
  {
    id: "totalTagihan",
    disablePadding: false,
    label: "TOTAL TAGIHAN",
    align: "left",
    minWidth: "200px",
  },
  {
    id: "bayarDalamTagih",
    disablePadding: false,
    label: "BAYAR DALAM TAGIHAN",
    align: "left",
    minWidth: "200px",
  },
  {
    id: "diskon",
    disablePadding: false,
    label: "DISKON",
    align: "left",
    minWidth: "200px",
  },
  {
    id: "bayarDalamRekap",
    disablePadding: false,
    label: "BAYAR DALAM REKAP",
    align: "left",
    minWidth: "200px",
  },
  {
    id: "bayarGabungan",
    disablePadding: false,
    label: "BAYAR GABUNGAN",
    align: "left",
    minWidth: "200px",
  },
  {
    id: "sisa",
    disablePadding: false,
    label: "SISA DALAM REKAP",
    align: "left",
    minWidth: "200px",
  },
  {
    id: "createdAt",
    disablePadding: false,
    label: "INSERTED TIME",
    sort: false,
    minWidth: "150px",
  },
  {
    id: "createdBy",
    disablePadding: false,
    label: "INSERTED BY",
    sort: false,
    minWidth: "150px",
  },
  {
    id: "updatedAt",
    disablePadding: false,
    label: "UPDATED TIME",
    sort: false,
    minWidth: "170px",
  },
  {
    id: "updatedBy",
    disablePadding: false,
    label: "UPDATED BY",
    sort: false,
    minWidth: "150px",
  },
]

export const deleteTagihanByID = async (id) => {
  try {
    const res = await instance3.post("/rekap-tagihan/delete", {
      id_tagihan: id,
    })

    if (res.data.status === 200) {
      return {
        state: true,
        message: "Berhasil menghapus data",
      }
    } else {
      return {
        state: false,
        message: res.data.message,
      }
    }
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    }
  }
}
